import React from "react";
import { Database } from "lucide-react";
import RoleScopedPlaceholder from "../../components/RoleScopedPlaceholder";

export default function PortalMasterDataPage() {
  return <RoleScopedPlaceholder title="Master Data" moduleKey="master_data" icon={Database} />;
}
